<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <div class="left-box">
            <el-form-item label="排班司机:">
              <div class="center-box-1">
                <span class="center-name" v-for="(item, index) in selectRows" :key="index">{{ item.username }}</span>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="发起日期:" prop="startDate">
            <custom-date-range
              :start-date="form.schedulingStartDate"
              :end-date="form.schedulingEndDate"
              @update:startDate="
                    (val) => (form.schedulingStartDate = val)
                  "
              @update:endDate="(val) => (form.schedulingEndDate = val)"></custom-date-range>
          </el-form-item>
          <el-form-item prop="schedulingStatus" label="状态">
            <el-radio-group v-model="form.schedulingStatus">
              <el-radio :label="1">出勤</el-radio>
              <el-radio :label="2">不出勤</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {schedulingDriverBatch } from "./api";
import dayjs from 'dayjs'
// 引入星期汉化
import 'dayjs/locale/zh-cn'
import CustomDateRange from "@/components/CustomDateRange.vue";
dayjs.locale('zh-cn')
export default {
  name: "AddOrEdit",
  components: {
    CustomDateRange,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "司机排班",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      detail: {},
      carImage: require("@/assets/imgs/title.png"),
      form: {
        "driverIds": [],
        "schedulingEndDate": "",
        "schedulingStartDate": "",
        "schedulingStatus": null
      },
      rules: {
        schedulingStatus: [{ required: true, message: "不能为空" }],
      },
      selectRows: []
    };
  },
  mounted() {},
  methods: {
    init(selectRows) {
      this.selectRows = selectRows
      this.dialogObj.show = true;
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let driverIds = []
          this.selectRows.forEach((item) => {
            driverIds.push(item.driverId);
          })
          const par = {
            driverIds: driverIds,
            schedulingStatus: this.form.schedulingStatus,
            schedulingStartDate: this.form.schedulingStartDate,
            schedulingEndDate: this.form.schedulingEndDate,
          };
          schedulingDriverBatch(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("排班成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
    font-size: 16px;
    .center-name{
      padding-right: 0.1rem;
    }
  }
}
</style>
